// trigger
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import routes from 'bundles/degree-home/routes';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

// remove the grid import once all bt3-container, bt3-row, and bt3-col classes are removed from this bundle
import 'css!bundles/degree-home/components/__styl__/grid';
import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);

export default appEnv;
